import "./main.css"
import "@mantine/notifications/styles.css"
import { MantineProvider } from "@mantine/core"
import { Notifications } from "@mantine/notifications"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { UI_BASE_URL, USE_FORGEROCK } from "@utils/constants.util"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { initializeForgeRock } from "./services/forgeRockConfig"
import SplunkRUMConfig from "./splunkRUMConfig"
import { cssVariableResolver, theme } from "./theme"

const queryClient = new QueryClient()
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

// Initialize ForgeRock SDK if enabled, then render the app
async function initializeApp() {
	try {
		// Initialize ForgeRock if enabled
		if (USE_FORGEROCK) {
			await initializeForgeRock()
		}
	} catch (error) {
		console.error("Failed to initialize ForgeRock SDK:", error)
		// Continue with app initialization even if ForgeRock fails
		// This allows fallback to traditional authentication
	}

	// Render the React app
	root.render(
		<MantineProvider
			theme={theme}
			cssVariablesResolver={cssVariableResolver}
			withGlobalClasses
		>
			<Notifications containerWidth={650} />
			<BrowserRouter basename={UI_BASE_URL}>
				<QueryClientProvider client={queryClient}>
					<App />
				</QueryClientProvider>
			</BrowserRouter>
		</MantineProvider>
	)
}

// Initialize the app
initializeApp()

SplunkRUMConfig()
reportWebVitals()
